// #region Type
export const ACTION_TYPE = {
  CALL_API_SELECT_SYSTEM_USER: 'CALL_API_SELECT_SYSTEM_USER',
  CALL_API_SELECT_SYSTEM_USER_SUCCESS: 'CALL_API_SELECT_SYSTEM_USER_SUCCESS',
  CALL_API_SYSTEM_USER_SEARCH: 'CALL_API_SYSTEM_USER_SEARCH',
  CALL_API_SYSTEM_USER_SEARCH_SUCCESS: 'CALL_API_SYSTEM_USER_SEARCH_SUCCESS',
  CALL_API_SYSTEM_USER_DELETE: 'CALL_API_SYSTEM_USER_DELETE',
  CALL_API_SYSTEM_USER_DELETE_SUCCESS: 'CALL_API_SYSTEM_USER_DELETE_SUCCESS',
  RESET_SYSTEM_USER_FLG: 'RESET_SYSTEM_USER_FLG',
};
// #endregion

// #region action
export const actCallApiSelectSystemUser = () => ({
  type: ACTION_TYPE.CALL_API_SELECT_SYSTEM_USER,
});

export const actCallApiSelectSystemUserSuccess = (selects) => ({
  type: ACTION_TYPE.CALL_API_SELECT_SYSTEM_USER_SUCCESS,
  selects,
});

export const actCallApiGetSystemUser = (searchCondition) => ({
  type: ACTION_TYPE.CALL_API_SYSTEM_USER_SEARCH,
  searchCondition,
});

export const actCallApiGetSystemUserSuccess = (datas) => ({
  type: ACTION_TYPE.CALL_API_SYSTEM_USER_SEARCH_SUCCESS,
  datas,
});

export const actCallApiSystemUserDelete = (param) => ({
  type: ACTION_TYPE.CALL_API_SYSTEM_USER_DELETE,
  param,
});

export const actCallApiSystemUserDeleteSuccess = () => ({
  type: ACTION_TYPE.CALL_API_SYSTEM_USER_DELETE_SUCCESS,
});

export const actResetSystemUserFlg = () => ({
  type: ACTION_TYPE.RESET_SYSTEM_USER_FLG,
});
// #endregion
